//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 20.02.2017.
 */

(function () {

    'use strict';

    angular.module('container.widgets')
        .directive('srsngFinderColumn', srsngFinderColumn);

    function srsngFinderColumn($compile) {

        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/widgets/finder/column/column.html',
            scope: {
                column: '=',
                selectItem: '&',
                filterChanged: '&',
                goToItem: '&'
            },            
            link: link
        };        

        function link(scope, element, attrs) {
            

            scope.$watchGroup(['column.baseWidth', 'column.expanded'], () => {

                let columnWidth;

                if (scope.column.expanded) {

                    let maxFullLabelColumnWidth = 0;

                    element.find('> .items .item').each((i, item) => {

                        let labelContainerWidth = $(item).find('.label')[0].getBoundingClientRect().width;
                        let fullLabelWidth = $(item).find('.label span')[0].getBoundingClientRect().width + 1; // Compensate for rounding imprecision

                        let fullLabelColumnWidth = parseFloat(element.css('flex-basis')) - labelContainerWidth + fullLabelWidth;

                        if (fullLabelColumnWidth > maxFullLabelColumnWidth) maxFullLabelColumnWidth = fullLabelColumnWidth;
                    });

                    columnWidth = Math.max(Math.min(maxFullLabelColumnWidth, 2 * scope.column.baseWidth), scope.column.baseWidth);

                } else {

                    columnWidth = scope.column.baseWidth;
                }

                element.css('flex-basis', columnWidth);
            });

            scope.isPlaceholder = () => scope.column.placeholder;

            scope.getToggleColumnIcon = () => {
                return `container/ui/assets/img/icons/system-icons-16x16/system-ic-column-width-${scope.column.expanded ? 'downsize' : 'enlarge'}-16x16.svg`;
            };

            scope.toggleColumn = () => {
                scope.column.expanded = !scope.column.expanded;
                $(window).trigger("resize.finder");
            };

            scope.resetFilter = () => {
                delete scope.column.filterText;
                scope.filterChanged();
            };           

            scope.itemActionMenu = {};

            scope.$watch('itemActionMenu.visible', newVal => {

                if (!newVal) {

                    let item = scope.itemActionMenu.item;

                    setTimeout(() => {
                        if (scope.itemActionMenu.item === item) scope.itemActionMenu = {};
                    }, 0)
                }
            });

            scope.showItemActionMenu = (event, item) => {

                if (scope.itemActionMenu.item !== item) {

                    var promises = [];
                    item.actionMenu.forEach(action => {
                        var newpromise = action.enabled(item);
                        promises.push(newpromise);
                    });

                    Promise.all(promises).then(
                        result => {
                            
                            scope.itemActionMenu = {
                                visible: true,
                                actionMenu: item.actionMenu,
                                isEnabled: result,
                                item: item
                            };

                            $compile(`
                                <srsng-popup class="item-action-menu-popup" visible="itemActionMenu.visible" target=".action-menu-button svg" anchor="right center" align="left center" offset="8 0" arrow="left" remove-on-hide>
                                    <div class="action-menu">
                                        <div class="list">
                                            <div ng-repeat="action in itemActionMenu.actionMenu track by $index"
                                                ng-init="enabled = itemActionMenu.isEnabled[$index] == true"
                                                class="item ng-class:{disabled:!enabled}"  
                                                ng-click="enabled && action.callback(itemActionMenu.item, column.index); enabled && (itemActionMenu.visible = false)">
                                                <span class="label">{{action.label | translate}}</span>
                                                <ng-include ng-if="!enabled" src="'container/ui/assets/img/icons/system-icons-16x16/system-ic-locked-16x16.svg'" style="margin-bottom: -3px;fill: rgba(248, 251, 250, 0.5);"></ng-include>
                                            </div>
                                        </div>
                                    </div>
                                </srsng-popup>
                            `)(scope).insertAfter(event.currentTarget);
                        }
                    );
                }

                event.stopPropagation();
            };

            scope.itemActionMenuVisible = item => {
                return scope.itemActionMenu.visible && scope.itemActionMenu.item === item;
            };

            scope.checkEllipsis = (event, item) => {
                let label = $(event.currentTarget).find('.label')[0];
                if (label.offsetWidth < label.scrollWidth) item.showTooltip = true;
                else delete item.showTooltip;
            };
        }
    }
})();